import styled, { css } from 'styled-components';

export const mediaQueries = {
  medium: (...args) =>
    css`
      @media (min-width: 50em) {
        ${css(...args)};
      }
    `,
  large: (...args) =>
    css`
      @media (min-width: 90em) {
        ${css(...args)};
      }
    `
};

export const spacing = ['0', '.25rem', '.5rem', '1rem', '2rem', '3rem', '4rem', '6rem', '8rem', '16rem'];

export const fontSizes = ['.75rem', '.875rem', '1rem', '1.25rem', '1.5rem', '2.25rem', '3rem', '5rem', '6rem'];

export const colors = { black: '#444', gray: '#999', background: 'rgb(245, 245, 250)' };

export const fonts = {
  sans: 'Geneva, Tahoma, Verdana, sans-serif;',
  serif: 'Hoefler Text,Baskerville Old Face,Garamond,Times New Roman,serif;'
};

export const Heading = styled.h1`
  color: ${colors.black};
  font-family: ${fonts.sans};
  font-weight: 100;
  font-size: calc(${fontSizes[4]} + 0.5vw);
  position: relative;
  margin: ${spacing[5]} 0;

  ${mediaQueries.medium`
    font-size: ${fontSizes[5]};
    margin: ${spacing[6]} 0;
  `};
`;

export const Paragraph = styled.p`
  color: ${colors.black};
  font-family: ${fonts.sans};
  font-weight: 100;
  font-size: ${fontSizes[2]};
  line-height: 1.8;
  max-width: ${props => props.maxWidth ? props.maxWidth : 'initial'};
  ${mediaQueries.medium`
    font-size: calc(${fontSizes[3]} * .9);

  `};
`;

export const Span = styled.span`
  color: ${colors.black};
  font-family: ${props => props.sans ? fonts.sans : fonts.serif};
  font-weight: 100;
  font-size: 1.1rem;
  line-height: 1.8;
  max-width: 28em;
`;

export const PageWrapper = styled.div`
  flex: 1;
  max-width: ${props => props.maxWidth ? props.maxWidth : '65rem'};
  margin: 0 auto;
`;

export const Measures = ['20rem', '30rem', '40rem'];

export const timing = ['.2s', '.4s', '.6s', '1s'];



// WEBPACK FOOTER //
// ./src/components/Styling.js